import { render, staticRenderFns } from "./add-variant-fild.vue?vue&type=template&id=cad361c4&scoped=true&"
import script from "./add-variant-fild.vue?vue&type=script&lang=ts&"
export * from "./add-variant-fild.vue?vue&type=script&lang=ts&"
import style0 from "./add-variant-fild.vue?vue&type=style&index=0&id=cad361c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cad361c4",
  null
  
)

export default component.exports